import styled from 'styled-components';
import { Spreadsheet } from '@progress/kendo-spreadsheet-react-wrapper';

export const RootDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  > {
    width: 100%;
    height: 100%;
  }
`;

export const StyledSpreadsheet = styled(Spreadsheet)`
  width: 100%;
  height: 100%;
`;
